export default __webpack_public_path__ + "static/media/arrow-right.d6d8be3f.svg";